import { useFitInOrderModal } from '@/components/modals/FitInOrderModal'

export function useFitInOrderButtonData() {
  const { show: showFitInOrderModal, Modal: FitInOrderModal } = useFitInOrderModal()

  return {
    fitInOrder: showFitInOrderModal,
    FitInOrderModal,
  }
}
